import { Flex, Paper, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { formatHumanizedDuration } from '@feature/utils';
import { Validation } from '@feature/validation/ValidationTypes';

interface ValidationCardProps {
  validation: Validation;
}

export function ValidationCard({ validation }: ValidationCardProps) {
  const { t } = useTranslation();

  return (
    <Paper p="sm">
      <Flex>
        {validation.status === 'VALIDATED' && <Text c="green">{t('validation.statusEnum.VALIDATED')}</Text>}
        {validation.status === 'REJECTED' && <Text c="red">{t('validation.statusEnum.REJECTED')}</Text>}
        <Text ml="6px">{t('validation.by')}</Text>
        <Text
          ml="6px"
          fw="500"
        >
          {validation.validatedBy.name}
        </Text>
      </Flex>
      <Text
        size="xs"
        c="dimmed"
        fs="italic"
      >
        {formatHumanizedDuration(validation.createdAt)}
      </Text>
      <Text>{validation.note}</Text>
    </Paper>
  );
}
